"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _productBox = require("@ori/product-box");
var _productBoxCarousel = require("@ori/product-box-carousel");
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _react = require("react");
var _productListClasses = _interopRequireDefault(require("../../containers/ProductListContainer/productListClasses"));
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const Carousel = ({
  renderItemComponent,
  items,
  isRefreshing,
  renderItemSkeleton,
  carousel
}) => {
  const {
    id,
    slider,
    showSkeletonIfEmpty,
    skeletonCount = _productBoxCarousel.DEFAULT_PRODUCT_BOX_SKELETON_COUNT,
    navigation: navigationProp,
    title
  } = carousel ?? {};
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const navigation = (0, _react.useMemo)(() => ({
    position: 'outside',
    showArrows: !isMobile,
    useBreakpointsPerView: true,
    ...navigationProp
  }), [isMobile, navigationProp]);
  const pagination = (0, _react.useMemo)(() => ({
    show: false
  }), []);
  if (items.length === 0 && !isRefreshing && !showSkeletonIfEmpty || !renderItemComponent) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
    hasFocusableSlides: true,
    className: _productListClasses.default.carousel,
    id: id,
    slider: (0, _productBoxCarousel.getSliderOptions)({
      slider,
      isMobile
    }),
    pagination: pagination,
    navigation: navigation,
    loading: isRefreshing,
    title: title,
    children: !!isRefreshing || items.length < 1 && showSkeletonIfEmpty ? (0, _times.default)(skeletonCount).map(index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
      minWidth: 175,
      children: renderItemSkeleton ? renderItemSkeleton() : /*#__PURE__*/(0, _jsxRuntime.jsx)(_productBox.ProductBoxSkeleton, {
        animation: isRefreshing ? 'pulse' : false
      })
    }, index)) : items.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.CarouselSlide, {
      minWidth: 175,
      children: renderItemComponent({
        index,
        item
      })
    }, (0, _utils.keyExtractor)(item, index)))
  });
};
exports.Carousel = Carousel;
